var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:1.0503;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.0503;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.6,3.4c0.9,0,1.6,0.7,1.6,1.6v16.4c0,0.9-0.7,1.6-1.6,1.6H3.4c-0.9,0-1.6-0.7-1.6-1.6V5c0-0.9,0.7-1.6,1.6-1.6H20.6  M20.6,2.4H3.4C2,2.4,0.8,3.5,0.8,5v16.4C0.8,22.8,2,24,3.4,24h17.1c1.4,0,2.6-1.2,2.6-2.6V5C23.2,3.5,22,2.4,20.6,2.4L20.6,2.4z "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.8,
    y1: 9.1,
    x2: 23.2,
    y2: 9.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7.3,
    y1: 0.6,
    x2: 7.3,
    y2: 5.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 16.7,
    y1: 0.6,
    x2: 16.7,
    y2: 5.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon_date.cf2909e6418885e14abcffd6de62f350.svg";
export { ForwardRef as ReactComponent };